'use client'

import { useEffect, useState } from 'react'

// Types
import type { RefObject } from 'react'

// True while the element is at least `amount` (0 to 1) visible in the viewport
const useInView = (ref: RefObject<Element | null>, amount = 0) => {
	const [inView, setInView] = useState(false)

	useEffect(() => {
		const element = ref.current

		if (!element) return

		const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), { threshold: amount })

		observer.observe(element)

		return () => observer.disconnect()
	}, [ref, amount])

	return inView
}

export default useInView
